// Deep imports, not the `@untitledui/icons` barrel (RSP-6864). Importing
// anything from the barrel loads all ~1,174 icon modules, and because
// packages/web depends on atomic-ui this one import was 1,174 files — 9% of
// web's 13,140-file type program. The package's exports map publishes a `./*`
// subpath, so each icon resolves on its own. Keep these as deep imports.
import { Activity } from '@untitledui/icons/Activity';
import { AlertTriangle } from '@untitledui/icons/AlertTriangle';
import { Asterisk02 } from '@untitledui/icons/Asterisk02';
import { BarChart10 } from '@untitledui/icons/BarChart10';
import { BezierCurve02 } from '@untitledui/icons/BezierCurve02';
import { Calendar } from '@untitledui/icons/Calendar';
import { Certificate02 } from '@untitledui/icons/Certificate02';
import { Check } from '@untitledui/icons/Check';
import { CheckCircle } from '@untitledui/icons/CheckCircle';
import { CheckCircleBroken } from '@untitledui/icons/CheckCircleBroken';
import { CheckVerified03 } from '@untitledui/icons/CheckVerified03';
import { ChevronDown } from '@untitledui/icons/ChevronDown';
import { ChevronLeft } from '@untitledui/icons/ChevronLeft';
import { ChevronRight } from '@untitledui/icons/ChevronRight';
import { ChevronUp } from '@untitledui/icons/ChevronUp';
import { ClipboardCheck } from '@untitledui/icons/ClipboardCheck';
import { Clock } from '@untitledui/icons/Clock';
import { Dataflow03 } from '@untitledui/icons/Dataflow03';
import { DotsVertical } from '@untitledui/icons/DotsVertical';
import { Download01 } from '@untitledui/icons/Download01';
import { Eye } from '@untitledui/icons/Eye';
import { EyeOff } from '@untitledui/icons/EyeOff';
import { File06 } from '@untitledui/icons/File06';
import { FileCheck01 } from '@untitledui/icons/FileCheck01';
import { FileDownload03 } from '@untitledui/icons/FileDownload03';
import { FilePlus02 } from '@untitledui/icons/FilePlus02';
import { FilterFunnel01 } from '@untitledui/icons/FilterFunnel01';
import { FilterLines } from '@untitledui/icons/FilterLines';
import { Grid01 } from '@untitledui/icons/Grid01';
import { InfoCircle } from '@untitledui/icons/InfoCircle';
import { LayersThree01 } from '@untitledui/icons/LayersThree01';
import { LinkExternal01 } from '@untitledui/icons/LinkExternal01';
import { List } from '@untitledui/icons/List';
import { Minus } from '@untitledui/icons/Minus';
import { NotificationMessage } from '@untitledui/icons/NotificationMessage';
import { Pencil01 } from '@untitledui/icons/Pencil01';
import { Play } from '@untitledui/icons/Play';
import { Plus } from '@untitledui/icons/Plus';
import { RefreshCcw02 } from '@untitledui/icons/RefreshCcw02';
import { ReverseLeft } from '@untitledui/icons/ReverseLeft';
import { Save01 } from '@untitledui/icons/Save01';
import { Settings01 } from '@untitledui/icons/Settings01';
import { Settings04 } from '@untitledui/icons/Settings04';
import { Table } from '@untitledui/icons/Table';
import { Trash01 } from '@untitledui/icons/Trash01';
import { Upload01 } from '@untitledui/icons/Upload01';
import { User01 } from '@untitledui/icons/User01';
import { Users01 } from '@untitledui/icons/Users01';
import { UsersPlus } from '@untitledui/icons/UsersPlus';
import { X } from '@untitledui/icons/X';
import { XCircle } from '@untitledui/icons/XCircle';
import { Zap } from '@untitledui/icons/Zap';
import { ZapFast } from '@untitledui/icons/ZapFast';
import {
  ArrowDownAZ,
  Check as Check2,
  Ellipsis,
  GripVertical,
  NotebookTabs,
  PenLine,
  Redo2,
  Trash2,
  Undo2,
  Wand2,
} from 'lucide-react';

export const IconMap = {
  activity: Activity,
  'alert-triangle': AlertTriangle,
  'arrow-down-az': ArrowDownAZ,
  'asterisk-02': Asterisk02,
  'bar-chart-10': BarChart10,
  'bezier-curve-02': BezierCurve02,
  calendar: Calendar,
  'certificate-02': Certificate02,
  check: Check,
  'check-2': Check2,
  'check-circle': CheckCircle,
  'check-circle-broken': CheckCircleBroken,
  'check-verified-03': CheckVerified03,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'clipboard-check': ClipboardCheck,
  clock: Clock,
  'data-flow-03': Dataflow03,
  'dots-vertical': DotsVertical,
  'download-01': Download01,
  ellipsis: Ellipsis,
  eye: Eye,
  'eye-off': EyeOff,
  'file-06': File06,
  'file-check-01': FileCheck01,
  'file-download-03': FileDownload03,
  'file-plus-02': FilePlus02,
  'filter-funnel-01': FilterFunnel01,
  'filter-lines': FilterLines,
  'grid-01': Grid01,
  'grip-vertical': GripVertical,
  'info-circle': InfoCircle,
  'layers-three-01': LayersThree01,
  'link-external-01': LinkExternal01,
  list: List,
  minus: Minus,
  'notebook-tabs': NotebookTabs,
  'notification-message': NotificationMessage,
  'pen-line': PenLine,
  'pencil-01': Pencil01,
  play: Play,
  plus: Plus,
  'save-01': Save01,
  'redo-2': Redo2,
  'refresh-02': RefreshCcw02,
  'reverse-left': ReverseLeft,
  'settings-01': Settings01,
  'settings-04': Settings04,
  table: Table,
  'trash-01': Trash01,
  'trash-2': Trash2,
  'undo-2': Undo2,
  'upload-01': Upload01,
  'user-01': User01,
  'users-01': Users01,
  'users-plus': UsersPlus,
  wand: Wand2,
  x: X,
  'x-circle': XCircle,
  zap: Zap,
  'zap-fast': ZapFast,
};

export const commonIcons = Object.keys(IconMap).sort();

export type IconName = keyof typeof IconMap;
